var _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _g3, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _g4, _path112, _path113, _g5, _path114, _path115, _g6, _g7, _g8, _g9, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 297,
    viewBox: "0 0 1440 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_431_13636)",
    filter: "url(#filter0_d_431_13636)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_431_13636)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 1440,
    height: 289,
    fill: "#BBDFE9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4594 88.9755C79.5617 84.5673 83.3637 73.6081 78.9514 64.4975C74.5392 55.3868 63.5834 51.5748 54.4812 55.983C45.3789 60.3913 41.5769 71.3505 45.9891 80.4611C50.4014 89.5717 61.3571 93.3838 70.4594 88.9755Z",
    fill: "#0F4699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1511 68.1085L61.9483 82.1435C61.9761 82.2102 62.0215 82.2682 62.0796 82.3113C62.1377 82.3544 62.2063 82.381 62.2782 82.3882C62.3502 82.3955 62.4227 82.3833 62.4882 82.3527C62.5537 82.3221 62.6097 82.2745 62.6503 82.2147L70.3669 69.8141C70.4037 69.7514 70.4244 69.6807 70.4273 69.608C70.4302 69.5354 70.4151 69.4632 70.3835 69.3977C70.3518 69.3323 70.3044 69.2757 70.2457 69.2329C70.1869 69.1902 70.1185 69.1626 70.0465 69.1526L55.5328 67.5181C55.4608 67.5117 55.3884 67.5251 55.3234 67.5568C55.2584 67.5885 55.2033 67.6374 55.1641 67.6981C55.1248 67.7588 55.1028 67.8291 55.1006 67.9014C55.0983 67.9737 55.1158 68.0453 55.1511 68.1085Z",
    fill: "#F2F2F2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter2_d_431_13636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.035 81.7294L-26.0058 80.5517L-6.17654 33.6888L33.8355 39.182L27.035 81.7294Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.033 192.007L151.992 190.829L171.822 143.966L211.834 149.459L205.033 192.007Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.28922 343.926L-62.33 342.748L-42.5008 295.885L-2.48876 301.378L-9.28922 343.926Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.956 152.51L56.0066 151.342L76.9892 101.93L119.189 107.663L111.956 152.51Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.443 260.575L237.402 259.397L257.232 212.535L297.244 218.028L290.443 260.575Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.351 269.547L73.3106 268.369L93.1399 221.506L133.152 226.999L126.351 269.547Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.374 231.394L135.839 230.456L151.746 192.877L183.833 197.276L178.374 231.394Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.085 75.9188L195.044 74.7411L214.873 27.8783L254.885 33.3715L248.085 75.9188Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7645 227.837L-19.2763 226.659L0.552952 179.796L40.565 185.289L33.7645 227.837Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5 34.2059L102.459 33.0282L122.288 -13.8346L162.3 -8.34143L155.5 34.2059Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.762 338.115L158.721 336.937L178.55 290.075L218.562 295.568L211.762 338.115Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.497 144.483L280.456 143.306L300.285 96.4427L340.297 101.936L333.497 144.483Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1422 4.25395L-6.46417 34.5473L-17.5781 -16.4384L17.195 -35.4298L36.1422 4.25395Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4039 308.163L49.7975 338.457L38.6836 287.471L73.4567 268.479L92.4039 308.163Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.139 114.532L171.533 144.826L160.419 93.84L195.192 74.8485L214.139 114.532Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.18201 266.45L-42.7884 296.744L-53.9024 245.758L-19.1292 226.767L-0.18201 266.45Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.553 72.8194L78.947 103.113L67.833 52.1271L102.606 33.1357L121.553 72.8194Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.551 183.098L256.945 213.391L245.831 162.405L280.604 143.414L299.551 183.098Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.458 192.072L92.8513 222.366L81.7373 171.38L116.51 152.389L135.458 192.072Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.192 -1.55659L214.586 28.7368L203.472 -22.2489L238.245 -41.2403L257.192 -1.55659Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8717 150.362L0.265318 180.656L-10.8486 129.67L23.9245 110.679L42.8717 150.362Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.869 260.64L178.262 290.933L167.148 239.947L201.922 220.956L220.869 260.64Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.604 67.0088L299.998 97.3022L288.884 46.3165L323.657 27.3251L342.604 67.0088Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.70642 34.2959L-49.3128 64.5893L-60.4268 13.6036L-25.6537 -5.38779L-6.70642 34.2959Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5553 338.202L6.94891 368.496L-4.16505 317.51L30.6081 298.518L49.5553 338.202Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.291 144.574L128.684 174.868L117.57 123.882L152.343 104.891L171.291 144.574Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7047 102.861L36.0983 133.155L24.9844 82.1691L59.7575 63.1776L78.7047 102.861Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.703 213.139L214.096 243.432L202.982 192.446L237.756 173.455L256.703 213.139Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.609 222.114L50.0026 252.408L38.8887 201.422L73.6618 182.431L92.609 222.114Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.342 28.4825L171.736 58.7758L160.622 7.79015L195.395 -11.2013L214.342 28.4825Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3024 275.939L9.69598 306.232L-1.41798 255.246L33.3551 236.255L52.3024 275.939Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.037 82.3077L131.43 112.601L120.316 61.6153L155.09 42.6239L174.037 82.3077Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0220919 180.401L-42.5843 210.695L-53.6983 159.709L-18.9251 140.718L0.0220919 180.401Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57464 119.239L-38.1614 146.958L-50.1457 98.5469L-15.9761 81.3404L3.57464 119.239Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.756 -13.2304L79.1501 17.0629L68.0361 -33.9227L102.809 -52.9142L121.756 -13.2304Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.019 290.679L135.413 320.972L124.299 269.986L159.072 250.995L178.019 290.679Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.755 97.0479L257.148 127.341L246.034 76.3556L280.807 57.3642L299.755 97.0479Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4518 29.2041L40.8454 59.4975L29.7314 8.51183L64.5046 -10.4796L83.4518 29.2041Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.713 333.113L97.1071 363.407L85.9932 312.421L120.766 293.43L139.713 333.113Z",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.45 139.481L218.843 169.775L207.729 118.789L242.503 99.7978L261.45 139.481Z",
    stroke: "#3D3D3D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.48 -89C1034.57 -74.7928 1077.24 -34.5925 1133.49 -44.3341C1164.27 -49.6711 1208.45 -34.3865 1222.85 1.32987C1222.85 1.32987 1237.29 71.7993 1312.53 57.0767C1344.03 50.9149 1375.15 67.8294 1397.48 96.84C1407.3 109.598 1425.49 131.962 1423.06 146.494C1422.01 152.771 1416.71 156.602 1412.56 160.943C1401.01 173.08 1395.39 193.918 1406.14 213.234C1416.02 230.979 1440.95 237.197 1453.52 252.864C1512.66 326.563 1424.43 347.265 1403.69 351.03",
    stroke: "#174997",
    strokeWidth: 1.88,
    strokeMiterlimit: 10,
    strokeDasharray: "11.32 11.32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1269.45 230.333C1264.75 235.278 1260.3 238.461 1256.78 240.979C1215.46 270.578 1166.57 261.949 1156.18 259.842C1140.83 256.733 1111.17 250.719 1089.73 225.546C1057.29 187.464 1062.34 127.467 1087.5 87.8639C1092.1 80.6162 1116.42 40.4124 1165.85 33.9627C1195.76 30.0633 1230.62 37.928 1255.87 59.0459C1308.87 103.363 1305.09 192.894 1269.45 230.333Z",
    fill: "url(#paint0_linear_431_13636)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.9 46.7716C1116.29 45.8749 1117.43 44.6902 1118.54 45.0522C1129.86 48.7131 1158.65 61.6536 1167.59 100.179C1178.79 148.519 1196.33 160.982 1214.06 165.886C1214.06 165.886 1193.26 168.37 1174.8 155.972C1129.46 125.55 1127.77 62.6902 1116.9 46.7716Z",
    fill: "#11992F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.99 58.5683C1132.04 63.2575 1134.97 68.0043 1137.7 72.8663C1140.45 77.7036 1143.04 82.6314 1145.44 87.6414C1147.81 92.6597 1150.08 97.7273 1152.09 102.894C1154.13 108.052 1155.91 113.3 1157.67 118.582C1159.47 123.847 1161.25 129.161 1163.65 134.278C1166.05 139.387 1169.2 144.257 1173.31 148.379C1174.34 149.407 1175.39 150.419 1176.51 151.357C1177.61 152.32 1178.75 153.233 1179.92 154.121C1182.27 155.898 1184.77 157.519 1187.41 158.958C1192.7 161.821 1198.56 163.919 1204.63 165.26C1205.28 165.4 1205.97 165.038 1206.19 164.446C1206.41 163.87 1206.09 163.286 1205.47 163.129H1205.46C1203.99 162.767 1202.54 162.381 1201.11 161.945C1200.4 161.739 1199.7 161.5 1198.99 161.27C1198.3 161.023 1197.58 160.793 1196.89 160.521C1194.13 159.485 1191.48 158.267 1188.95 156.869C1183.89 154.105 1179.34 150.6 1175.41 146.668C1173.46 144.677 1171.71 142.554 1170.15 140.292C1168.59 138.03 1167.24 135.644 1166.05 133.176C1163.67 128.232 1161.86 122.983 1160.02 117.735C1158.17 112.486 1156.27 107.229 1154.12 102.071C1153.05 99.4878 1151.93 96.9293 1150.76 94.3955C1150.19 93.1204 1149.58 91.8617 1148.97 90.603C1148.36 89.3526 1147.73 88.1021 1147.09 86.8516C1144.53 81.8827 1141.79 76.9961 1138.88 72.2164C1135.93 67.4449 1132.84 62.7639 1129.55 58.2146C1129.46 58.083 1129.25 58.0583 1129.09 58.157C1128.95 58.2557 1128.9 58.4367 1128.99 58.5683Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.59 147.91C1180.96 149.44 1178.98 149.827 1177.8 148.675C1171.3 142.291 1154.57 122.572 1157.57 91.2942C1160.1 64.8866 1158.96 50.3172 1157.98 43.744C1157.78 42.3537 1159.47 41.5064 1160.46 42.5018C1171.43 53.5009 1204.26 92.594 1181.59 147.91Z",
    fill: "#C6D800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.35 147.836C1179.31 147.861 1179.27 147.877 1179.23 147.893C1178.89 148.017 1178.52 147.844 1178.41 147.515C1178.27 147.137 1164.49 109.253 1166.35 72.3644C1166.36 72.0106 1166.67 71.7391 1167.02 71.7556C1167.38 71.772 1167.65 72.0764 1167.63 72.4302C1165.79 109.047 1179.47 146.692 1179.61 147.071C1179.73 147.359 1179.61 147.68 1179.35 147.836Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1184 251.821H1267.42C1267.89 251.821 1268.27 251.443 1268.27 250.974V43.6862C1268.27 43.2173 1267.89 42.8389 1267.42 42.8389H1184C1183.53 42.8389 1183.15 43.2173 1183.15 43.6862V250.982C1183.15 251.443 1183.53 251.821 1184 251.821Z",
    fill: "url(#paint1_linear_431_13636)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.08 251.821H1294.51C1295.25 251.821 1295.85 251.22 1295.85 250.48V44.1798C1295.85 43.4394 1295.25 42.8389 1294.51 42.8389H1212.08C1211.34 42.8389 1210.73 43.4394 1210.73 44.1798V250.488C1210.73 251.229 1211.34 251.821 1212.08 251.821Z",
    fill: "url(#paint2_linear_431_13636)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1285.2 73.8038H1220.14C1218.33 73.8038 1216.84 71.8458 1216.84 69.4436V57.1941C1216.84 54.7919 1218.32 52.834 1220.14 52.834H1285.2C1287.02 52.834 1288.5 54.7919 1288.5 57.1941V69.4354C1288.49 71.8458 1287.02 73.8038 1285.2 73.8038ZM1220.14 53.9281C1218.78 53.9281 1217.67 55.3925 1217.67 57.2023V69.4436C1217.67 71.2453 1218.77 72.7178 1220.14 72.7178H1285.2C1286.56 72.7178 1287.68 71.2535 1287.68 69.4436V57.1941C1287.68 55.3925 1286.57 53.9199 1285.2 53.9199H1220.14V53.9281Z",
    fill: "#BDD0FB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1285.2 107.344H1220.14C1218.33 107.344 1216.84 105.386 1216.84 102.984V90.7429C1216.84 88.3408 1218.32 86.3828 1220.14 86.3828H1285.2C1287.02 86.3828 1288.5 88.3408 1288.5 90.7429V102.984C1288.49 105.386 1287.02 107.344 1285.2 107.344ZM1220.14 87.4687C1218.78 87.4687 1217.67 88.9331 1217.67 90.7429V102.984C1217.67 104.786 1218.77 106.258 1220.14 106.258H1285.2C1286.56 106.258 1287.68 104.794 1287.68 102.984V90.7429C1287.68 88.9413 1286.57 87.4687 1285.2 87.4687H1220.14Z",
    fill: "#BDD0FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1285.2 142.949H1220.14C1218.33 142.949 1216.84 140.991 1216.84 138.589V126.347C1216.84 123.945 1218.32 121.987 1220.14 121.987H1285.2C1287.02 121.987 1288.5 123.945 1288.5 126.347V138.589C1288.49 140.991 1287.02 142.949 1285.2 142.949ZM1220.14 123.073C1218.78 123.073 1217.67 124.538 1217.67 126.347V138.589C1217.67 140.39 1218.77 141.863 1220.14 141.863H1285.2C1286.56 141.863 1287.68 140.399 1287.68 138.589V126.347C1287.68 124.546 1286.57 123.073 1285.2 123.073H1220.14Z",
    fill: "#BDD0FB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1285.2 176.498H1220.14C1218.33 176.498 1216.84 174.54 1216.84 172.138V159.896C1216.84 157.494 1218.32 155.536 1220.14 155.536H1285.2C1287.02 155.536 1288.5 157.494 1288.5 159.896V172.138C1288.49 174.54 1287.02 176.498 1285.2 176.498ZM1220.14 156.622C1218.78 156.622 1217.67 158.086 1217.67 159.896V172.138C1217.67 173.939 1218.77 175.412 1220.14 175.412H1285.2C1286.56 175.412 1287.68 173.947 1287.68 172.138V159.896C1287.68 158.095 1286.57 156.622 1285.2 156.622H1220.14Z",
    fill: "#BDD0FB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1284.78 210.901H1219.73C1217.91 210.901 1216.43 208.943 1216.43 206.541V194.3C1216.43 191.897 1217.91 189.939 1219.73 189.939H1284.79C1286.6 189.939 1288.09 191.897 1288.09 194.3V206.541C1288.08 208.943 1286.6 210.901 1284.78 210.901ZM1219.73 191.025C1218.37 191.025 1217.25 192.49 1217.25 194.3V206.541C1217.25 208.343 1218.36 209.815 1219.73 209.815H1284.79C1286.15 209.815 1287.26 208.351 1287.26 206.541V194.3C1287.26 192.498 1286.16 191.025 1284.79 191.025H1219.73Z",
    fill: "#BDD0FB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1285.2 245.256H1220.14C1218.33 245.256 1216.84 243.298 1216.84 240.895V228.654C1216.84 226.252 1218.32 224.294 1220.14 224.294H1285.2C1287.02 224.294 1288.5 226.252 1288.5 228.654V240.895C1288.49 243.298 1287.02 245.256 1285.2 245.256ZM1220.14 225.38C1218.78 225.38 1217.67 226.844 1217.67 228.654V240.895C1217.67 242.697 1218.77 244.17 1220.14 244.17H1285.2C1286.56 244.17 1287.68 242.705 1287.68 240.895V228.654C1287.68 226.852 1286.57 225.38 1285.2 225.38H1220.14Z",
    fill: "#BDD0FB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.13 64.392C1223 64.392 1223.71 63.7216 1223.71 62.8947C1223.71 62.0678 1223 61.3975 1222.13 61.3975C1221.25 61.3975 1220.54 62.0678 1220.54 62.8947C1220.54 63.7216 1221.25 64.392 1222.13 64.392Z",
    fill: "#BDD0FB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.13 98.3607C1223 98.3607 1223.71 97.6904 1223.71 96.8635C1223.71 96.0366 1223 95.3662 1222.13 95.3662C1221.25 95.3662 1220.54 96.0366 1220.54 96.8635C1220.54 97.6904 1221.25 98.3607 1222.13 98.3607Z",
    fill: "#BDD0FB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.13 133.34C1223 133.34 1223.71 132.67 1223.71 131.843C1223.71 131.016 1223 130.346 1222.13 130.346C1221.25 130.346 1220.54 131.016 1220.54 131.843C1220.54 132.67 1221.25 133.34 1222.13 133.34Z",
    fill: "#BDD0FB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.13 167.505C1223 167.505 1223.71 166.835 1223.71 166.008C1223.71 165.181 1223 164.511 1222.13 164.511C1221.25 164.511 1220.54 165.181 1220.54 166.008C1220.54 166.835 1221.25 167.505 1222.13 167.505Z",
    fill: "#BDD0FB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.13 201.917C1223 201.917 1223.71 201.247 1223.71 200.42C1223.71 199.593 1223 198.923 1222.13 198.923C1221.25 198.923 1220.54 199.593 1220.54 200.42C1220.54 201.247 1221.25 201.917 1222.13 201.917Z",
    fill: "#BDD0FB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.44 236.272C1222.31 236.272 1223.02 235.602 1223.02 234.775C1223.02 233.948 1222.31 233.277 1221.44 233.277C1220.57 233.277 1219.86 233.948 1219.86 234.775C1219.86 235.602 1220.57 236.272 1221.44 236.272Z",
    fill: "#BDD0FB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.91 234.43H1229.31V243.726H1231.91V234.43Z",
    fill: "#BDD0FB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.24 237.621H1233.65V243.725H1236.24V237.621Z",
    fill: "#BDD0FB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.58 229.724H1237.98V243.725H1240.58V229.724Z",
    fill: "#BDD0FB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.92 240.36H1242.32V243.725H1244.92V240.36Z",
    fill: "#BDD0FB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1249.25 231.6H1246.66V243.726H1249.25V231.6Z",
    fill: "#BDD0FB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.58 233.697H1250.98V243.726H1253.58V233.697Z",
    fill: "#BDD0FB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.91 235.984H1255.32V243.734H1257.91V235.984Z",
    fill: "#BDD0FB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.25 226.894H1259.65V243.725H1262.25V226.894Z",
    fill: "#BDD0FB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.59 228.679H1263.99V243.725H1266.59V228.679Z",
    fill: "#BDD0FB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.92 231.369H1268.32V243.726H1270.92V231.369Z",
    fill: "#BDD0FB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.25 240.673H1272.65V243.725H1275.25V240.673Z",
    fill: "#BDD0FB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1279.58 234.75H1276.99V243.725H1279.58V234.75Z",
    fill: "#BDD0FB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.98 199.532H1229.39V208.828H1231.98V199.532Z",
    fill: "#BDD0FB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.32 202.732H1233.72V208.837H1236.32V202.732Z",
    fill: "#BDD0FB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.65 194.835H1238.06V208.837H1240.65V194.835Z",
    fill: "#BDD0FB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.98 205.472H1242.38V208.836H1244.98V205.472Z",
    fill: "#BDD0FB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1249.32 196.702H1246.72V208.828H1249.32V196.702Z",
    fill: "#BDD0FB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.65 198.809H1251.06V208.837H1253.65V198.809Z",
    fill: "#BDD0FB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.99 201.087H1255.39V208.836H1257.99V201.087Z",
    fill: "#BDD0FB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.32 192.005H1259.73V208.837H1262.32V192.005Z",
    fill: "#BDD0FB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.65 193.782H1264.05V208.829H1266.65V193.782Z",
    fill: "#BDD0FB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.99 196.48H1268.39V208.837H1270.99V196.48Z",
    fill: "#BDD0FB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.32 205.785H1272.72V208.837H1275.32V205.785Z",
    fill: "#BDD0FB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1279.66 199.854H1277.06V208.829H1279.66V199.854Z",
    fill: "#BDD0FB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.08 165.269H1228.48V174.565H1231.08V165.269Z",
    fill: "#BDD0FB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.41 168.46H1232.82V174.564H1235.41V168.46Z",
    fill: "#BDD0FB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.75 160.562H1237.15V174.564H1239.75V160.562Z",
    fill: "#BDD0FB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.08 171.199H1241.49V174.564H1244.08V171.199Z",
    fill: "#BDD0FB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.41 162.438H1245.81V174.565H1248.41V162.438Z",
    fill: "#BDD0FB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.75 164.536H1250.15V174.564H1252.75V164.536Z",
    fill: "#BDD0FB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.08 166.823H1254.49V174.573H1257.08V166.823Z",
    fill: "#BDD0FB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.42 157.732H1258.82V174.564H1261.42V157.732Z",
    fill: "#BDD0FB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.75 159.518H1263.16V174.564H1265.75V159.518Z",
    fill: "#BDD0FB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.08 162.208H1267.48V174.564H1270.08V162.208Z",
    fill: "#BDD0FB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.41 171.512H1271.82V174.564H1274.41V171.512Z",
    fill: "#BDD0FB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.75 165.589H1276.15V174.564H1278.75V165.589Z",
    fill: "#BDD0FB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.15 131.621H1228.55V140.917H1231.15V131.621Z",
    fill: "#BDD0FB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.48 134.821H1232.88V140.925H1235.48V134.821Z",
    fill: "#BDD0FB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.81 126.924H1237.22V140.926H1239.81V126.924Z",
    fill: "#BDD0FB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.15 137.561H1241.55V140.925H1244.15V137.561Z",
    fill: "#BDD0FB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.49 128.791H1245.89V140.917H1248.49V128.791Z",
    fill: "#BDD0FB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.82 130.897H1250.22V140.926H1252.82V130.897Z",
    fill: "#BDD0FB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.15 133.176H1254.55V140.925H1257.15V133.176Z",
    fill: "#BDD0FB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.48 124.094H1258.89V140.926H1261.48V124.094Z",
    fill: "#BDD0FB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.82 125.871H1263.22V140.918H1265.82V125.871Z",
    fill: "#BDD0FB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.15 128.569H1267.56V140.926H1270.15V128.569Z",
    fill: "#BDD0FB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.49 137.873H1271.89V140.925H1274.49V137.873Z",
    fill: "#BDD0FB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.82 131.942H1276.22V140.918H1278.82V131.942Z",
    fill: "#BDD0FB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.08 96.1885H1228.48V105.485H1231.08V96.1885Z",
    fill: "#BDD0FB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.41 99.3887H1232.82V105.493H1235.41V99.3887Z",
    fill: "#BDD0FB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.75 91.4912H1237.15V105.493H1239.75V91.4912Z",
    fill: "#BDD0FB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.08 102.128H1241.49V105.493H1244.08V102.128Z",
    fill: "#BDD0FB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.41 93.3584H1245.81V105.485H1248.41V93.3584Z",
    fill: "#BDD0FB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.75 95.4561H1250.15V105.484H1252.75V95.4561Z",
    fill: "#BDD0FB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.08 97.7432H1254.49V105.493H1257.08V97.7432Z",
    fill: "#BDD0FB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.42 88.6611H1258.82V105.493H1261.42V88.6611Z",
    fill: "#BDD0FB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.75 90.4385H1263.16V105.485H1265.75V90.4385Z",
    fill: "#BDD0FB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.08 93.1279H1267.48V105.484H1270.08V93.1279Z",
    fill: "#BDD0FB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.41 102.433H1271.82V105.485H1274.41V102.433Z",
    fill: "#BDD0FB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.75 96.5098H1276.15V105.485H1278.75V96.5098Z",
    fill: "#BDD0FB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.15 62.5498H1228.55V71.8459H1231.15V62.5498Z",
    fill: "#BDD0FB"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.48 65.7412H1232.88V71.8454H1235.48V65.7412Z",
    fill: "#BDD0FB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.81 57.8438H1237.22V71.8455H1239.81V57.8438Z",
    fill: "#BDD0FB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.15 68.4805H1241.55V71.8452H1244.15V68.4805Z",
    fill: "#BDD0FB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.49 59.7197H1245.89V71.8458H1248.49V59.7197Z",
    fill: "#BDD0FB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.82 61.8174H1250.22V71.8457H1252.82V61.8174Z",
    fill: "#BDD0FB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.15 64.0957H1254.55V71.8452H1257.15V64.0957Z",
    fill: "#BDD0FB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.48 55.0137H1258.89V71.8454H1261.48V55.0137Z",
    fill: "#BDD0FB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.82 56.7988H1263.22V71.8454H1265.82V56.7988Z",
    fill: "#BDD0FB"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.15 59.4893H1267.56V71.8457H1270.15V59.4893Z",
    fill: "#BDD0FB"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.49 68.793H1271.89V71.8451H1274.49V68.793Z",
    fill: "#BDD0FB"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.82 62.8701H1276.22V71.8454H1278.82V62.8701Z",
    fill: "#BDD0FB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.47 222.953L1144.32 251.565H1192.51L1186.23 222.953H1148.47Z",
    fill: "url(#paint3_linear_431_13636)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.53 131.358V216.504C1067.53 223.505 1073.13 229.239 1080.14 229.42C1111.3 230.218 1220.29 232.167 1249.95 231.731C1255.05 231.657 1259.18 227.585 1259.32 222.501C1259.89 202.716 1260.82 155.149 1257.38 133.069C1256.66 128.421 1252.73 124.941 1248.01 124.793C1221.9 123.962 1106.38 121.313 1076.73 121.979C1071.61 122.078 1067.53 126.249 1067.53 131.358Z",
    fill: "url(#paint4_linear_431_13636)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.88 130.939V211.84C1072.88 215.928 1076.17 219.26 1080.27 219.326L1245.67 221.366C1249.74 221.424 1253.07 218.166 1253.08 214.11L1253.36 133.933C1253.37 131.037 1251.06 128.66 1248.15 128.586L1078.81 125.172C1075.56 125.09 1072.88 127.697 1072.88 130.939Z",
    fill: "url(#paint5_linear_431_13636)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.33 224.698L1072.88 221.613C1072.74 221.613 1072.62 221.497 1072.63 221.358C1072.63 221.218 1072.76 221.103 1072.89 221.111L1254.33 224.196C1254.47 224.196 1254.59 224.311 1254.58 224.451C1254.57 224.591 1254.47 224.698 1254.33 224.698Z",
    fill: "#91B3FA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.39 228.465C1164.21 228.465 1163.25 227.503 1163.25 226.326C1163.25 225.15 1164.21 224.188 1165.39 224.188C1166.57 224.188 1167.53 225.15 1167.53 226.326C1167.53 227.503 1166.57 228.465 1165.39 228.465ZM1165.39 224.698C1164.49 224.698 1163.76 225.43 1163.76 226.326C1163.76 227.223 1164.49 227.955 1165.39 227.955C1166.29 227.955 1167.02 227.223 1167.02 226.326C1167.02 225.43 1166.29 224.698 1165.39 224.698Z",
    fill: "#91B3FA"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.89 259.167H1132.36C1130.45 259.167 1129.01 257.81 1129.38 256.345L1130.29 252.775C1130.56 251.697 1131.75 250.916 1133.15 250.866L1201.14 248.752C1202.61 248.703 1203.91 249.484 1204.23 250.603L1205.86 256.296C1206.28 257.769 1204.83 259.167 1202.89 259.167Z",
    fill: "url(#paint6_linear_431_13636)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.33 251.862C1170.19 251.862 1170.07 251.755 1170.07 251.615C1170.07 251.476 1170.18 251.36 1170.32 251.36L1173.23 251.319C1173.37 251.319 1173.49 251.426 1173.49 251.566C1173.49 251.706 1173.38 251.821 1173.24 251.821L1170.33 251.862Z",
    fill: "#91B3FA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.98 257.226C1131.97 257.226 1131.96 257.226 1131.94 257.226C1131.8 257.202 1131.71 257.078 1131.73 256.938L1132.14 254.339C1132.36 252.932 1133.57 251.896 1134.99 251.871L1165.89 251.418C1166.03 251.41 1166.15 251.525 1166.15 251.665C1166.15 251.805 1166.04 251.92 1165.9 251.92L1135 252.373C1133.82 252.389 1132.83 253.245 1132.64 254.413L1132.23 257.013C1132.22 257.136 1132.11 257.226 1131.98 257.226Z",
    fill: "#91B3FA"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1184.15 182.125H1177.76V215.147H1184.15V182.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.84 182.125H1188.45V215.147H1194.84V182.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.53 182.125H1199.14V215.147H1205.53V182.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.23 182.125H1209.83V215.147H1216.23V182.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.92 182.125H1220.53V215.147H1226.92V182.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.61 182.125H1231.22V215.147H1237.61V182.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.31 182.125H1241.91V215.147H1248.31V182.125Z",
    fill: "white"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.15 197.862H1177.76V215.138H1184.15V197.862Z",
    fill: "#91B3FA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.84 203.803H1188.45V215.147H1194.84V203.803Z",
    fill: "#91B3FA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.53 189.126H1199.14V215.147H1205.53V189.126Z",
    fill: "#91B3FA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.23 208.895H1209.83V215.147H1216.23V208.895Z",
    fill: "#91B3FA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.92 192.605H1220.53V215.147H1226.92V192.605Z",
    fill: "#91B3FA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1237.61 196.505H1231.22V215.138H1237.61V196.505Z",
    fill: "#91B3FA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.31 200.75H1241.91V215.147H1248.31V200.75Z",
    fill: "#91B3FA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M1093.64 188.805C1086.34 188.805 1080.41 194.711 1080.41 202.008C1080.41 209.297 1086.33 215.212 1093.64 215.212C1100.95 215.212 1106.87 209.306 1106.87 202.008C1106.87 194.72 1100.95 188.805 1093.64 188.805ZM1093.64 209.528C1089.48 209.528 1086.11 206.163 1086.11 202.008C1086.11 197.854 1089.48 194.489 1093.64 194.489C1097.81 194.489 1101.18 197.854 1101.18 202.008C1101.18 206.163 1097.81 209.528 1093.64 209.528Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_431_13636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1080,
    y: 188,
    width: 27,
    height: 28
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.64 188.805C1086.34 188.805 1080.41 194.711 1080.41 202.008C1080.41 209.297 1086.33 215.212 1093.64 215.212C1100.95 215.212 1106.87 209.306 1106.87 202.008C1106.87 194.72 1100.95 188.805 1093.64 188.805ZM1093.64 209.528C1089.48 209.528 1086.11 206.163 1086.11 202.008C1086.11 197.854 1089.48 194.489 1093.64 194.489C1097.81 194.489 1101.18 197.854 1101.18 202.008C1101.18 206.163 1097.81 209.528 1093.64 209.528Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_431_13636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1114.45 199.104H1075.17V215.698H1114.45V199.104Z",
    fill: "#91B3FA"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M1125.89 188.805C1118.58 188.805 1112.66 194.711 1112.66 202.008C1112.66 209.297 1118.58 215.212 1125.89 215.212C1133.19 215.212 1139.12 209.306 1139.12 202.008C1139.11 194.72 1133.19 188.805 1125.89 188.805ZM1125.89 209.528C1121.72 209.528 1118.35 206.163 1118.35 202.008C1118.35 197.854 1121.72 194.489 1125.89 194.489C1130.05 194.489 1133.42 197.854 1133.42 202.008C1133.42 206.163 1130.05 209.528 1125.89 209.528Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_431_13636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1112,
    y: 188,
    width: 28,
    height: 28
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.89 188.805C1118.58 188.805 1112.66 194.711 1112.66 202.008C1112.66 209.297 1118.58 215.212 1125.89 215.212C1133.19 215.212 1139.12 209.306 1139.12 202.008C1139.11 194.72 1133.19 188.805 1125.89 188.805ZM1125.89 209.528C1121.72 209.528 1118.35 206.163 1118.35 202.008C1118.35 197.854 1121.72 194.489 1125.89 194.489C1130.05 194.489 1133.42 197.854 1133.42 202.008C1133.42 206.163 1130.05 209.528 1125.89 209.528Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_431_13636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1146.7 192.688H1107.42V215.698H1146.7V192.688Z",
    fill: "#91B3FA"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M1158.12 188.805C1150.82 188.805 1144.89 194.711 1144.89 202.008C1144.89 209.297 1150.81 215.212 1158.12 215.212C1165.43 215.212 1171.35 209.306 1171.35 202.008C1171.35 194.72 1165.43 188.805 1158.12 188.805ZM1158.12 209.528C1153.96 209.528 1150.59 206.163 1150.59 202.008C1150.59 197.854 1153.96 194.489 1158.12 194.489C1162.28 194.489 1165.66 197.854 1165.66 202.008C1165.66 206.163 1162.28 209.528 1158.12 209.528Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_431_13636",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1144,
    y: 188,
    width: 28,
    height: 28
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.12 188.805C1150.82 188.805 1144.89 194.711 1144.89 202.008C1144.89 209.297 1150.81 215.212 1158.12 215.212C1165.43 215.212 1171.35 209.306 1171.35 202.008C1171.35 194.72 1165.43 188.805 1158.12 188.805ZM1158.12 209.528C1153.96 209.528 1150.59 206.163 1150.59 202.008C1150.59 197.854 1153.96 194.489 1158.12 194.489C1162.28 194.489 1165.66 197.854 1165.66 202.008C1165.66 206.163 1162.28 209.528 1158.12 209.528Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_431_13636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1178.93 207.405H1139.65V215.706H1178.93V207.405Z",
    fill: "#91B3FA"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1181.56 136.541H1158.2C1157.22 136.541 1156.43 137.265 1156.43 138.162C1156.43 139.058 1157.22 139.782 1158.2 139.782H1181.56C1182.54 139.782 1183.33 139.058 1183.33 138.162C1183.33 137.265 1182.54 136.541 1181.56 136.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.56 143.706H1158.2C1157.22 143.706 1156.43 144.43 1156.43 145.327C1156.43 146.223 1157.22 146.947 1158.2 146.947H1181.56C1182.54 146.947 1183.33 146.223 1183.33 145.327C1183.33 144.43 1182.54 143.706 1181.56 143.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.56 172.385H1158.2C1157.22 172.385 1156.43 173.109 1156.43 174.005C1156.43 174.902 1157.22 175.626 1158.2 175.626H1181.56C1182.54 175.626 1183.33 174.902 1183.33 174.005C1183.33 173.109 1182.54 172.385 1181.56 172.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.56 165.219H1158.2C1157.22 165.219 1156.43 165.943 1156.43 166.839C1156.43 167.736 1157.22 168.46 1158.2 168.46H1181.56C1182.54 168.46 1183.33 167.736 1183.33 166.839C1183.33 165.943 1182.54 165.219 1181.56 165.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.56 158.046H1158.2C1157.22 158.046 1156.43 158.77 1156.43 159.667C1156.43 160.563 1157.22 161.287 1158.2 161.287H1181.56C1182.54 161.287 1183.33 160.563 1183.33 159.667C1183.33 158.77 1182.54 158.046 1181.56 158.046Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1214.01 136.541H1190.66C1189.68 136.541 1188.89 137.265 1188.89 138.162C1188.89 139.058 1189.68 139.782 1190.66 139.782H1214.01C1214.99 139.782 1215.79 139.058 1215.79 138.162C1215.79 137.265 1214.99 136.541 1214.01 136.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.01 143.706H1190.66C1189.68 143.706 1188.89 144.43 1188.89 145.327C1188.89 146.223 1189.68 146.947 1190.66 146.947H1214.01C1214.99 146.947 1215.79 146.223 1215.79 145.327C1215.79 144.43 1214.99 143.706 1214.01 143.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.01 172.385H1190.66C1189.68 172.385 1188.89 173.109 1188.89 174.005C1188.89 174.902 1189.68 175.626 1190.66 175.626H1214.01C1214.99 175.626 1215.79 174.902 1215.79 174.005C1215.79 173.109 1214.99 172.385 1214.01 172.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.01 165.219H1190.66C1189.68 165.219 1188.89 165.943 1188.89 166.839C1188.89 167.736 1189.68 168.46 1190.66 168.46H1214.01C1214.99 168.46 1215.79 167.736 1215.79 166.839C1215.79 165.943 1214.99 165.219 1214.01 165.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.01 158.046H1190.66C1189.68 158.046 1188.89 158.77 1188.89 159.667C1188.89 160.563 1189.68 161.287 1190.66 161.287H1214.01C1214.99 161.287 1215.79 160.563 1215.79 159.667C1215.79 158.77 1214.99 158.046 1214.01 158.046Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.47 136.541H1223.12C1222.14 136.541 1221.35 137.265 1221.35 138.162C1221.35 139.058 1222.14 139.782 1223.12 139.782H1246.47C1247.45 139.782 1248.24 139.058 1248.24 138.162C1248.24 137.265 1247.45 136.541 1246.47 136.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.47 143.706H1223.12C1222.14 143.706 1221.35 144.43 1221.35 145.327C1221.35 146.223 1222.14 146.947 1223.12 146.947H1246.47C1247.45 146.947 1248.24 146.223 1248.24 145.327C1248.24 144.43 1247.45 143.706 1246.47 143.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.47 172.385H1223.12C1222.14 172.385 1221.35 173.109 1221.35 174.005C1221.35 174.902 1222.14 175.626 1223.12 175.626H1246.47C1247.45 175.626 1248.24 174.902 1248.24 174.005C1248.24 173.109 1247.45 172.385 1246.47 172.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.47 165.219H1223.12C1222.14 165.219 1221.35 165.943 1221.35 166.839C1221.35 167.736 1222.14 168.46 1223.12 168.46H1246.47C1247.45 168.46 1248.24 167.736 1248.24 166.839C1248.24 165.943 1247.45 165.219 1246.47 165.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.47 158.046H1223.12C1222.14 158.046 1221.35 158.77 1221.35 159.667C1221.35 160.563 1222.14 161.287 1223.12 161.287H1246.47C1247.45 161.287 1248.24 160.563 1248.24 159.667C1248.24 158.77 1247.45 158.046 1246.47 158.046Z",
    fill: "white"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.51 177.715H1143.74C1145.5 177.715 1146.93 176.292 1146.93 174.531V91.9686C1146.93 90.2163 1145.5 88.7931 1143.75 88.7848L1088.07 88.6368C1086.3 88.6285 1084.86 90.0682 1084.87 91.8369L1085.32 174.556C1085.33 176.3 1086.75 177.715 1088.51 177.715Z",
    fill: "#91B3FA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1091.21 92.709L1140.6 93.0134C1142.39 93.0216 1143.82 94.4778 1143.81 96.2547L1143.47 170.361C1143.46 172.113 1142.05 173.544 1140.3 173.577L1092.31 174.449C1090.52 174.482 1089.04 173.051 1089.01 171.266L1087.96 95.9832C1087.93 94.1734 1089.4 92.7008 1091.21 92.709Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1093.22 96.863V97.2003C1093.22 97.7351 1093.66 98.1628 1094.19 98.1628H1132.24C1132.78 98.1628 1133.21 97.7268 1133.21 97.2003V96.863C1133.21 96.3283 1132.77 95.9005 1132.24 95.9005H1094.19C1093.65 95.8923 1093.22 96.3283 1093.22 96.863Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1097.47 101.133C1097.49 101.635 1097.91 102.038 1098.42 102.046L1131.69 102.655C1132.23 102.663 1132.68 102.227 1132.68 101.692V101.61C1132.68 101.084 1132.26 100.656 1131.72 100.648L1098.45 100.121C1097.89 100.113 1097.43 100.574 1097.47 101.133Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M1094.07 171.964C1092.55 171.964 1091.29 170.738 1091.27 169.217L1090.19 108.602C1090.16 107.064 1091.39 105.781 1092.94 105.756L1137.87 104.884C1138.62 104.876 1139.33 105.147 1139.87 105.666C1140.42 106.184 1140.72 106.883 1140.73 107.632L1141.89 168.575C1141.91 169.323 1141.63 170.039 1141.1 170.574C1140.57 171.117 1139.87 171.413 1139.12 171.421L1094.11 171.964C1094.09 171.964 1094.08 171.964 1094.07 171.964ZM1137.92 105.896C1137.91 105.896 1137.9 105.896 1137.89 105.896L1092.96 106.768C1091.97 106.784 1091.18 107.607 1091.2 108.586L1092.28 169.2C1092.3 170.171 1093.1 170.961 1094.08 170.961C1094.09 170.961 1094.1 170.961 1094.1 170.961L1139.12 170.418C1139.59 170.409 1140.05 170.22 1140.38 169.875C1140.72 169.529 1140.9 169.077 1140.89 168.591L1139.73 107.648C1139.72 107.171 1139.52 106.727 1139.17 106.389C1138.83 106.069 1138.39 105.896 1137.92 105.896Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M1140.29 111.992H1091.27C1090.99 111.992 1090.77 111.77 1090.77 111.49C1090.77 111.21 1090.99 110.988 1091.27 110.988H1140.29C1140.57 110.988 1140.79 111.21 1140.79 111.49C1140.8 111.77 1140.58 111.992 1140.29 111.992Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M1117.16 160.234C1106.53 160.234 1097.9 151.612 1097.9 141.008C1097.9 130.404 1106.53 121.782 1117.16 121.782C1127.78 121.782 1136.42 130.404 1136.42 141.008C1136.42 151.612 1127.78 160.234 1117.16 160.234ZM1117.16 127.812C1109.86 127.812 1103.94 133.736 1103.94 141.008C1103.94 148.289 1109.87 154.204 1117.16 154.204C1124.45 154.204 1130.38 148.28 1130.38 141.008C1130.38 133.736 1124.45 127.812 1117.16 127.812Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.37 139.568L1130.35 140.021C1130.37 140.35 1130.38 140.679 1130.38 141.008C1130.38 142.579 1130.1 144.093 1129.6 145.492L1135.27 147.54C1136.02 145.5 1136.42 143.303 1136.42 141.008C1136.42 140.523 1136.4 140.046 1136.37 139.568Z",
    fill: "url(#paint7_linear_431_13636)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.16 154.204C1109.86 154.204 1103.94 148.28 1103.94 141.008C1103.94 133.727 1109.87 127.812 1117.16 127.812C1118.27 127.812 1119.35 127.952 1120.38 128.207L1121.86 122.358C1120.36 121.98 1118.78 121.782 1117.17 121.782C1106.54 121.782 1097.9 130.404 1097.9 141.008C1097.9 151.612 1106.54 160.234 1117.17 160.234C1125.49 160.234 1132.6 154.936 1135.28 147.532L1129.6 145.483C1127.76 150.567 1122.88 154.204 1117.16 154.204Z",
    fill: "url(#paint8_linear_431_13636)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.35 140.02L1136.37 139.568C1136.19 137.084 1135.52 134.723 1134.47 132.592L1129.04 135.233C1129.76 136.697 1130.21 138.318 1130.35 140.02Z",
    fill: "url(#paint9_linear_431_13636)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_431_13636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1067.14 158.437C1057.04 158.17 1045.47 163.354 1038.11 171.486C1031.13 171.559 1024.32 174.359 1019.28 179.314C1018.99 179.598 1018.88 180.026 1019.01 180.416C1019.13 180.807 1019.47 181.093 1019.87 181.154L1028.17 182.415L1027.14 183.556C1026.75 183.98 1026.77 184.629 1027.17 185.038L1040.91 199.018C1041.12 199.229 1041.39 199.337 1041.67 199.339C1041.93 199.341 1042.19 199.253 1042.39 199.071L1043.55 198.054L1044.67 206.377C1044.73 206.783 1045.04 207.083 1045.43 207.216C1045.53 207.249 1045.63 207.265 1045.74 207.266C1046.04 207.268 1046.36 207.137 1046.57 206.926C1051.54 202.039 1054.46 195.276 1054.65 188.306C1062.91 181.066 1068.34 169.592 1068.19 159.499C1068.18 158.925 1067.72 158.457 1067.14 158.437ZM1057.05 176.97C1055.99 178.012 1054.6 178.526 1053.22 178.514C1051.84 178.503 1050.46 177.965 1049.42 176.906C1047.34 174.785 1047.36 171.364 1049.48 169.279C1051.6 167.194 1055.02 167.223 1057.11 169.344C1059.19 171.465 1059.17 174.887 1057.05 176.97Z",
    fill: "#0F4699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.01 194.511C1019.68 196.799 1016.42 207.198 1016.06 208.375C1015.94 208.754 1016.04 209.166 1016.32 209.449C1016.52 209.658 1016.8 209.77 1017.08 209.773C1017.18 209.774 1017.29 209.759 1017.39 209.73C1018.57 209.386 1029.03 206.306 1031.35 204.018C1033.97 201.441 1034.01 197.212 1031.43 194.591C1028.85 191.97 1024.63 191.936 1022.01 194.511Z",
    fill: "#0F4699"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_431_13636",
    x: -3,
    y: 0,
    width: 1448,
    height: 297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.870588 0 0 0 0 0.94902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_431_13636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_431_13636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_431_13636",
    x: -2,
    y: 1,
    width: 1448,
    height: 297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_431_13636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_431_13636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_431_13636",
    x: -199.725,
    y: -161.217,
    width: 547.957,
    height: 628.93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_431_13636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_431_13636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_13636",
    x1: 1325.78,
    y1: 330.415,
    x2: 1067.6,
    y2: 8.52035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_431_13636",
    x1: 1342.02,
    y1: 40.7355,
    x2: 1296.02,
    y2: 83.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#254A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_431_13636",
    x1: 1301.95,
    y1: 1.42764,
    x2: 1169.14,
    y2: 401.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#436192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1517A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_431_13636",
    x1: 1168.86,
    y1: 204.717,
    x2: 1168.03,
    y2: 292.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#170C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_431_13636",
    x1: 1164.55,
    y1: 119.625,
    x2: 1162.48,
    y2: 228.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_431_13636",
    x1: 1209,
    y1: 96.3934,
    x2: 1128.2,
    y2: 230.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7AD4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7AD4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_431_13636",
    x1: 1165.55,
    y1: 210.152,
    x2: 1168.03,
    y2: 266.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_431_13636",
    x1: 1143.89,
    y1: 133.128,
    x2: 1098.91,
    y2: 176.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_431_13636",
    x1: 1133.73,
    y1: 95.479,
    x2: 1118.82,
    y2: 136.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_431_13636",
    x1: 1142.38,
    y1: 121.868,
    x2: 1124.96,
    y2: 149.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_431_13636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 289,
    fill: "white",
    transform: "translate(0 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_431_13636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.7649,
    height: 51.7649,
    fill: "white",
    transform: "translate(1016.44 158) rotate(0.486035)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg5);
export default __webpack_public_path__ + "static/media/bg5.b9fa56f2ef4be7fcb6c8ae663b472637.svg";
export { ForwardRef as ReactComponent };